export default "__VITE_ASSET__BQCGS6te__"